import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";

import { SettingsOptions } from "../../../core/config/global-settings";
import { LanguageContext, SettingsContext } from "../../../core/store";

import { Row } from "../../../core/styles";
import { ReactComponent as CloseIcon } from "../../../assets/images/menu-close.svg";
import Selectbox from "../../Selectbox";
import { FormElement, Label, Panel, SettingsTitle, IconWrapper } from "../style";
import { Switch, SwitchButton, ToggleSwitchWrapper } from "../../Header/style";

const GeneralSettings = ({ handleClosePopup }) => {

    const { translate } = useContext(LanguageContext);

    const { options } = SettingsOptions;

    const { settingsState, dispatch } = useContext(SettingsContext);

    const [formValues, setFormValues] = useState(settingsState.global.initialValues);
    const [currentFontSize, setCurrentFontSize] = useState();

    const handleChange = (change) => {
        setFormValues({
            ...formValues,
            [change.name]: change.value
        });
    };

    const saveSettings = () => {
        let action = {
            type: "CREATE_GLOBAL_SETTINGS",
            payload: {
                initialValues: formValues
            }
        };

        dispatch(action);
    };

    const handleFontSizeChange = () => {
        const [small, big] = options.fontSize.options;

        setFormValues({
            ...formValues,
            fontSize: formValues.fontSize === small.value ? big.value : small.value
        });

        setCurrentFontSize(formValues.fontSize === small.value ? "isBig" : "isSmall");

    };

    useEffect(() => {
        const [small] = options.fontSize.options;
        setCurrentFontSize(formValues.fontSize === small.value ? "isSmall" : "isBig");
        saveSettings();
    }, [formValues]);

    return (
        <Row noPadding>
            <Panel>
                <IconWrapper onClick={handleClosePopup}>
                    <CloseIcon />
                </IconWrapper>
                <SettingsTitle>{translate("utils.generalSettings")}</SettingsTitle>
                <FormElement>
                    <Label>{translate("utils.fontSize")}</Label>
                    <ToggleSwitchWrapper>
                        <Switch onClick={handleFontSizeChange}>
                            <SwitchButton size={currentFontSize} />
                        </Switch>
                    </ToggleSwitchWrapper>
                </FormElement>

                <FormElement>
                    <Label>{translate("utils.pageChangeTime")}</Label>
                    <Selectbox
                        name="pageChangeTime"
                        selectedList={formValues.pageChangeTime}
                        settingsInfo={options.pageChangeTime.options}
                        itemValue={translate("utils.pageChangeTimeLabel")}
                        onSelected={(e) => handleChange(e)}
                    />
                </FormElement>

                <FormElement>
                    <Label>{translate("utils.matchTimeRange")}</Label>
                    <Selectbox
                        name="matchTimeRange"
                        settingsInfo={options.matchTimeRange.options}
                        selectedList={formValues.matchTimeRange}
                        itemValue={translate("utils.matchTimeRangeLabel")}
                        onSelected={(e) => handleChange(e)}
                    />
                </FormElement>
            </Panel>
        </Row>
    );
};

GeneralSettings.propTypes = {
    handleClosePopup: PropTypes.func.isRequired
};
export default GeneralSettings;
